import { useAuth } from "@/context/AuthContext";

/** True when the operator has a verified platform-admin JWT. */
export function useAdminSession() {
  const auth = useAuth();
  return auth.status === "authenticated";
}